export default function PlayIcon() {return(
	<svg className={'playSymbol'} width="20" height="22" viewBox="0 0 20 22" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			d="M18.5396 12.7028L3.42823 21.7265C2.14579 22.4915 0.5 21.5652 0.5 20.0229V1.97568C0.5 0.435901 2.14342 -0.492858 3.42823 0.27459L18.5396 9.29821C18.8313 9.4696 19.0738 9.71734 19.2425 10.0163C19.4112 10.3153 19.5 10.6548 19.5 11.0005C19.5 11.3462 19.4112 11.6858 19.2425 11.9848C19.0738 12.2837 18.8313 12.5315 18.5396 12.7028Z"
			fill="white"/>
	</svg>
)}